import styled from 'styled-components';
import { Wrapper } from '../shared/commonStyles';
import FadeInFromBottom from '../shared/FadeInFromBottom';

import AppBannerImage from '../../assets/image/app_banner/app_banner.png';
import AppStoreButtonImage from '../../assets/image/app_banner/app_store_download.png';
import GooglePlayButtonImage from '../../assets/image/app_banner/google_play_download.png';

const AppBannerWrapper = styled.section`
  position: relative;
`;

const AppBanner = styled.img`
  width: 100%;
  height: auto;
`;

const BaseButton = styled.img`
  width: 37%;
  height: auto;
  cursor: pointer;
  position: absolute;
  bottom: 15%;
`;

const AppStoreButton = styled(BaseButton)`
  left: 10%;
`;

const GooglePlayButton = styled(BaseButton)`
  right: 10%;
`;

const SectionAppBanner = () => {

  return (
    <Wrapper id="app-banner">
      <FadeInFromBottom>
        <AppBannerWrapper>
          <AppBanner src={AppBannerImage} alt="App Storeからダウンロード、Google Playからダウンロード" />
          <AppStoreButton 
            src={AppStoreButtonImage} 
            alt='App Storeからダウンロード'
            onClick={() => {
              window.open('https://apps.apple.com/jp/app/placole-dressy-%E3%83%97%E3%83%A9%E3%82%B3%E3%83%AC-%E3%83%89%E3%83%AC%E3%82%B7%E3%83%BC-%E7%B5%90%E5%A9%9A%E5%BC%8F%E8%8A%B1%E5%AB%81/id1222480403', '_blank');
            }}/>
          <GooglePlayButton
            src={GooglePlayButtonImage}
            alt='Google Playからダウンロード'
            onClick={() => {
              window.open('https://play.google.com/store/apps/details?id=com.placole.android.dressy', '_blank');
            }}/>
        </AppBannerWrapper>
      </FadeInFromBottom>
    </Wrapper>
  );
  };
  
export default SectionAppBanner;
  